var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("reports.title")))]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c("el-tab-pane", {
            attrs: { label: _vm.$t("reports.executions"), name: "executions" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _vm.activeTab === "executions"
            ? _c(
                "div",
                { staticClass: "filters" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "" },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", [_vm._v(_vm._s(_vm.$t("period")))])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: { size: "mini" },
                              on: { change: _vm.handleDateFilterChange },
                              model: {
                                value: _vm.dateFilter,
                                callback: function($$v) {
                                  _vm.dateFilter = $$v
                                },
                                expression: "dateFilter"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.dateFilters.past3Months"
                                  ),
                                  value: "past3Months"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.dateFilters.past6Months"
                                  ),
                                  value: "past6Months"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.dateFilters.past12Months"
                                  ),
                                  value: "past12Months"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.dateFilters.year2025"
                                  ),
                                  value: "2025"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.dateFilters.year2024"
                                  ),
                                  value: "2024"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.dateFilters.year2023"
                                  ),
                                  value: "2023"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.dateFilters.customRange"
                                  ),
                                  value: "custom"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("payment_plan.dateFilters.all"),
                                  value: "all"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.dateFilter === "custom"
                        ? _c(
                            "el-form-item",
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  size: "mini",
                                  type: "daterange",
                                  "range-separator": "-",
                                  "start-placeholder": _vm.$t("startDate"),
                                  "end-placeholder": _vm.$t("endDate"),
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.customDateRange,
                                  callback: function($$v) {
                                    _vm.customDateRange = $$v
                                  },
                                  expression: "customDateRange"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                disabled: !_vm.filtersChanged
                              },
                              on: { click: _vm.handleApplyFilters }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("apply")) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", disabled: !_vm.canReset },
                              on: { click: _vm.handleResetFilters }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("reset")) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.columnDefs.length > 0
            ? _c("rslt-ag-grid", {
                key: _vm.activeTab,
                attrs: {
                  loading: _vm.loading,
                  "grid-key": "reports-grid",
                  "grid-class": "reports-grid",
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.reports,
                  "pagination-page-size": _vm.limit
                },
                on: { "grid-ready": _vm.onGridReady }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }